import React from "react";

export interface ChevronIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Width & height of the icon. Accepts number (pixels) or any valid CSS size string.
   * @default 24
   */
  size?: number | string;
  /**
   * Stroke color of the chevron.
   * @default "currentColor"
   */
  color?: string;
}

/**
 * A lightweight, flexible chevron SVG that scales cleanly and inherits color.
 *
 * ```tsx
 * <ChevronIcon size={32} color="#4F46E5" />
 * ```
 */
const ChevronIcon: React.FC<ChevronIconProps> = ({
  size = 24,
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <polyline points="6 4 14 12 6 20" />
  </svg>
);

export default ChevronIcon;
